import { accessErrorNotification } from 'components/shared/AccessError/accessErrorNotification';
import { useCallback } from 'react';

export const useAccessErrorNotification = () =>
  useCallback((message?: string) => {
    accessErrorNotification(message);
  }, []);
